export const DEFAULT_VARIANT_NAME = 'default'
